const externalRoutes = [
  {
    path: "/diag/ext",
    name: "diagExt",
    meta: {
      title: "외부 진단",
      isDynamic: false,
    },
    component: () => import("@/layout/LayoutSimple.vue"),
    children: [
      {
        path: "take",
        name: "diagExtTake",
        meta: {
          title: "진단 실시",
          isDynamic: false,
        },
        component: () => import("@/views/external/diag/DiagAbilityTake.vue"),
      },
      {
        path: "result",
        name: "diagExtResult",
        meta: {
          title: "진단 결과",
          isDynamic: false,
        },
        component: () => import("@/views/external/diag/DiagAbilityExtResult.vue"),
      },
    ],
  },
];

export default externalRoutes;
